import { Node, mergeAttributes } from '@tiptap/core'

const Div = Node.create({
  name: 'div',
  group: 'block',
  content: 'block+',
  defining: false,

  parseHTML() {
    return [
      {
        tag: 'div',
        getAttrs: (node) => {
          if (typeof node === 'string') {
            return false
          }
          if (
            node.classList?.contains('iframe-wrapper')
            || node.classList?.contains('johku-columns')
            || node.classList?.contains('johku-column')
          ) {
            return false
          }
          return null
        },
      },
    ]
  },

  renderHTML({ HTMLAttributes }) {
    return ['div', mergeAttributes(HTMLAttributes), 0]
  },
})

export default Div
